import { render } from "./ViewsProductsProxy.vue?vue&type=template&id=09ea8fae"
import script from "./ViewsProductsProxy.vue?vue&type=script&lang=js"
export * from "./ViewsProductsProxy.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__